import script from "./segment.vue?vue&type=script&lang=ts&setup=true"
export * from "./segment.vue?vue&type=script&lang=ts&setup=true"

import "./segment.vue?vue&type=style&index=0&id=8be4ffde&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8be4ffde"]])

export default __exports__